module.exports = __webpack_public_path__ + "img/welcome-banner-tablet@2x.1a161b52.png";